import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-smart-upload',
  templateUrl: './smart-upload.component.html',
  styleUrls: ['./smart-upload.component.scss']
})
export class SmartUploadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
